module.exports = __webpack_public_path__ + "img/100.f982b101.jpg";